// URLのアンカーを取得して、recoverだった場合パンくずの表示を変更する
// 表示を切り替えるタグの取得
const breadcrumbLogin = document.getElementById('breadcrumbLogin');

window.addEventListener('hashchange', () => {
    // アンカーの取得
    let urlHash = location.hash;
    if (urlHash == '#recover') {
        breadcrumbLogin.textContent = "> パスワードリセット";
    } else {
        breadcrumbLogin.textContent = "> ログイン";
    }
});

